export default __webpack_public_path__ + "static/18aa-5397c41047ed5a6e67c51e3f8d01bd42.png";